import { render, staticRenderFns } from "./OfertsHotelPricesSupRed.vue?vue&type=template&id=193d6282&scoped=true&"
import script from "./OfertsHotelPricesSupRed.vue?vue&type=script&lang=js&"
export * from "./OfertsHotelPricesSupRed.vue?vue&type=script&lang=js&"
import style0 from "./OfertsHotelPricesSupRed.vue?vue&type=style&index=0&id=193d6282&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193d6282",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VIcon,VListItem,VListItemTitle,VRow,VSelect,VTextField,VTooltip})
